import { render, staticRenderFns } from "./CqXg.vue?vue&type=template&id=8761e8fa&scoped=true"
import script from "./CqXg.vue?vue&type=script&lang=js"
export * from "./CqXg.vue?vue&type=script&lang=js"
import style0 from "./CqXg.vue?vue&type=style&index=0&id=8761e8fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8761e8fa",
  null
  
)

export default component.exports